import { Role } from 'utils/helpers/auth0.helpers';

// NOTE: this can be refined later
export const subscriptionTiers = {
  t0: 'Savi Lite',
  t1: 'Savi Pro',
};

export type SubscriptionTier = keyof typeof subscriptionTiers;

export enum TenantType {
  SUPPLIER = 1,
  HOSPITAL = 2,
  ADMIN_OPERATIONS = 3,
}

export type UserTenant = {
  id: string;
  name: string;
  description: string;
  type: TenantType;
  subscriptionId: SubscriptionTier;
};

export type UserLocation = {
  locationId: string;
  name: string;
  description: string;
  region: string;
  metadata?: {
    State?: string;
    'Hospital Provider Number'?: string;
    force_storage_passthrough?: boolean;
    tray_barcode_assignment?: TrayBarcodeAssignment;
    allow_skip_check_in?: AllowSkipCheckIn;
    barcode_type?: BarcodeType;
    remember_login_organisation?: boolean;
    enable_user_quick_switcher?: boolean;
    capture_tray_image_enabled?: boolean;
    capture_set_inspection_enabled?: boolean;
    name_sets_enabled?: boolean;
    require_color_at_check_in?: boolean;
    capture_tray_number_enabled?: boolean;
    consolidation_enabled?: boolean;
    max_consolidated_sets?: MaxConsolidatedSets;
    set_terminology?: SetTerminology;
    pin_login_enabled?: boolean;
    session_timeout_enabled?: boolean;
    session_timeout_idle_mins?: SessionTimeoutMinutes;
    session_timeout_warning_duration_mins?: SessionTimeoutMinutes;
  };
};

export type MaxConsolidatedSets = 2 | 3 | 4 | 5 | 6;
// FE owns the dropdown options, not a fixed union.
export type SessionTimeoutMinutes = number;

export type CurrentUserResponse = {
  userId: string;
  firebaseToken: string;
  saviAuthToken: string;
  tenant: UserTenant;
  location: UserLocation;
  metadata: {
    firebaseId: string | null;
    demo: string | null;
  };
  email: string;

  // the following legacy field and can be removed once all imps are updated
  tenantName: string;
  tenantType: TenantType;
  role?: Role;
};

export enum TrayBarcodeAssignment {
  Generate = 0, // default
  Capture = 1,
  Disabled = 2,
}

export enum SetTerminology {
  Set = 'Set', // default
  Caddy = 'Caddy',
}

export enum AllowSkipCheckIn {
  No = 0, // default
  Sets = 1,
  Implants = 2,
  All = 3,
}

export enum BarcodeType {
  Code128 = 'code128', // default
  ITF = 'itf',
  QRCode = 'qrcode',
  DataMatrix = 'datamatrix',
}

export type QuickSwitchUser = {
  userId: string;
  email: string;
};
